module.exports = __webpack_public_path__ + "static/power-img2-3-2bcf3b4528b2724c98b388aa4b9ff654.png";